// store/tasksSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTasks,
  fetchCreatedTasks,
  createTask,
  taskGroups,
  taskUsers,
  tasksApprove,
  myTasks,
  taskDetail,
  deleteTask,
  addTaskStep,
  completeTaskStep,
  deleteTaskStep,
  startTask,
  submitTask,
  submitTaskWithFile,
  
} from "./tasksThunk";

const initialState = {
  tasks: { items: [], total: 0, page: 1, page_size: 10, pages: 0, status_counts: {} },
  users: [],
  groups: [],
  tasksApproveList: [],
  myTasksList: [],
  tasksDetailData: {},
  deleteTaskData: [],
  currentPage: 1,
  createdTasks: { items: [], total: 0, page: 1, page_size: 10 },
  totalPages: 1,
  status: "idle",
  error: null,
};

const tasksApiSlice = createSlice({
  name: "tasksApi",
  initialState,

  extraReducers: (builder) => {
    builder

      .addCase(fetchCreatedTasks.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCreatedTasks.fulfilled, (state, action) => {
        state.status = "success";
        state.createdTasks = action.payload;
      })
      .addCase(fetchCreatedTasks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Fetch all tasks
      .addCase(fetchTasks.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTasks.fulfilled, (state, action) => {
        state.status = "success";
        state.tasks = action.payload;
      })
      .addCase(fetchTasks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Create a new task
      .addCase(createTask.pending, (state) => {
        state.status = "loading";
      })

      .addCase(createTask.fulfilled, (state, action) => {
        state.status = "success";
        // Task yaratilganda items array'ga qo'shamiz
        if (Array.isArray(state.tasks.items)) {
          state.tasks.items.unshift(action.payload);
          state.tasks.total += 1;
        }
      })

      .addCase(createTask.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.response || action.error.message;
      })

      // Fetch task users
      .addCase(taskUsers.pending, (state) => {
        state.status = "loading";
      })

      .addCase(taskUsers.fulfilled, (state, action) => {
        state.status = "success"
        state.users = action.payload
      })

      .addCase(taskUsers.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

      // Fetch task groups
      .addCase(taskGroups.pending, (state) => {
        state.status = "loading"
      })

      .addCase(taskGroups.fulfilled, (state, action) => {
        state.status = "success"
        state.groups = action.payload
      })

      .addCase(taskGroups.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

      // Approve tasks
      .addCase(tasksApprove.pending, (state) => {
        state.status = "loading"
      })

      .addCase(tasksApprove.fulfilled, (state, action) => {
        state.status = "success"
        state.tasksApproveList = action.payload
      })

      .addCase(tasksApprove.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })


      // My tasks
      .addCase(myTasks.pending, (state) => {
        state.status = "loading"
      })

      .addCase(myTasks.fulfilled, (state, action) => {
        state.status = "success"
        state.myTasksList = action.payload
      })

      .addCase(myTasks.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })


      // Task Detail
      .addCase(taskDetail.pending, (state) => {
        state.status = "loading"
      })

      .addCase(taskDetail.fulfilled, (state, action) => {
        state.status = "success"
        state.tasksDetailData = action.payload
      })

      .addCase(taskDetail.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

      // Task Delete
      .addCase(deleteTask.pending, (state) => {
        state.status = "loading"
      })

      .addCase(deleteTask.fulfilled, (state, action) => {
        state.status = "success"
        state.deleteTaskData = state.deleteTaskData.filter(
          (myTasksList) => myTasksList.id !== action.payload
        );
      })

      .addCase(deleteTask.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

      // Add Task Step
      .addCase(addTaskStep.pending, (state) => {
        state.status = "loading"
      })

      .addCase(addTaskStep.fulfilled, (state, action) => {
        state.status = "success"
        if (state.tasksDetailData.id === action.payload.taskId) {
          state.tasksDetailData.steps = [
            ...state.tasksDetailData.steps,
            action.payload.step,
          ]
        }
      })

      .addCase(addTaskStep.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || action.error.message
      })

      // Complete Task Step
      .addCase(completeTaskStep.pending, (state) => {
        state.status = "loading"
      })

      .addCase(completeTaskStep.fulfilled, (state, action) => {
        state.status = "success"
        if (state.tasksDetailData.id === action.payload.taskId) {
          state.tasksDetailData.steps = state.tasksDetailData.steps.map((step) =>
            step.id === action.payload.stepId
              ? { ...step, done: action.payload.done }
              : step
          )
        }
      })

      .addCase(completeTaskStep.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || action.error.message
      })

      // Delete Task Step
      .addCase(deleteTaskStep.pending, (state) => {
        state.status = "loading"
      })

      .addCase(deleteTaskStep.fulfilled, (state, action) => {
        state.status = "success"
        if (state.tasksDetailData.id === action.payload.taskId) {
          state.tasksDetailData.steps = state.tasksDetailData.steps.filter(
            (step) => step.id !== action.payload.stepId
          )
        }
      })

      .addCase(deleteTaskStep.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || action.error.message
      })

      // Start Task
      .addCase(startTask.pending, (state) => {
        state.status = "loading"
      })

      .addCase(startTask.fulfilled, (state, action) => {
        state.status = "success"
        state.tasksDetailData = {
          ...state.tasksDetailData,
          status: "in_progress",
        }
      })

      .addCase(startTask.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

      // Submit Task
      .addCase(submitTask.pending, (state) => {
        state.status = "loading"
      })

      .addCase(submitTask.fulfilled, (state, action) => {
        state.status = "success"
        state.tasksDetailData = {
          ...state.tasksDetailData,
          status: "submitted",
        }
      })

      .addCase(submitTask.rejected, (state, action) => {

        state.status = "failed"
        state.error = action.payload || action.error.message
      })

      // Submit Task with File
      .addCase(submitTaskWithFile.pending, (state) => {
        state.status = "loading"
      })

      .addCase(submitTaskWithFile.fulfilled, (state, action) => {
        state.status = "success"
        state.tasksDetailData = {
          ...state.tasksDetailData,
          status: "submitted",
        }
      })

      .addCase(submitTaskWithFile.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })

  },
});

export default tasksApiSlice.reducer;

